module.exports = __webpack_public_path__ + "static/media/calendar-next.dee46d0e.svg";